import React from 'react'
import { spawn } from 'redux-saga/effects'

export const DeleteIcon = ({openDeleteModal,data,enable}) => {
  return (
    <span style={{display:enable?"inline-block":"none"}} className='icon'><i  className="fa-regular fa-circle-xmark deleteIcon"  onClick={()=>openDeleteModal(data.id)}></i></span>
  )
}

export const EditIcon = ({openModal,data}) => {
  return (
    <span className='icon' ><i className="fa-solid fa-pen-to-square editIcon" onClick={(e)=>openModal(e,data,data.id)}></i></span>
  )
}

export const DateFilterIcon = ({openModal,dateData}) => {
  return (
    <span className='icon' > <i className="fa-solid fa-filter" onClick={(e)=>openModal(e,dateData)}></i></span>
  )
}


